import React, { FC } from "react";
import { ANALYSIS_MAP } from "./consts";

type Props = {
  analysis: string;
};
const MissingData: FC<Props> = ({ analysis }) => (
  <section className="flex width-50-pc">
    <div className="width-50-pc bold">{ANALYSIS_MAP[analysis]} status:</div>
    <div className="width-50-pc">
      Data is missing. Please try reanalyzing the sample.
    </div>
  </section>
);

export default MissingData;
